import "core-js/modules/es.array.concat.js";
var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('span', {
        staticClass: "x-svg-icon",
        on: {
            "click": function($event) {
                return _setup.emit('click', $event);
            }
        }
    }, [
        _c('svg', {
            style: {
                width: _setup.getSizeByKey('width'),
                height: _setup.getSizeByKey('height')
            }
        }, [
            _c('use', {
                attrs: {
                    "xlink:href": "#x-svg-icon-".concat(_vm.name)
                }
            })
        ]),
        _vm.dot || _vm.badge ? _c('span', {
            class: [
                'x-svg-icon__badge',
                {
                    'x-svg-icon__dot': _vm.dot
                }
            ]
        }, [
            _vm._v(" " + _vm._s(_vm.badge) + " ")
        ]) : _vm._e()
    ]);
};
var staticRenderFns = [];
export { render, staticRenderFns };
